import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/phabricator': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M323 262.1L322.9 249.1S344.6 229.3 344 227.9L334.5 207.9C333.9 206.5 305 207.4 305 207.4L295.6 198.1S295.8 169.6 294.4 169L274.3 159.8C272.9 159.2 253.6 180.8 253.6 180.8L240.5 180.6S220 159.2 218.6 159.8L198.6 168.1C197.2 168.6 198.8 197 198.8 197L189.7 206.1S160.5 205.2 160 206.5L151.9 226.3C151.3 227.7 172.9 247.3 172.9 247.3L173 260.2S151.3 280 151.9 281.4L161.4 301.4C162 302.8 190.9 301.9 190.9 301.9L200.3 311.2S200.1 343 201.5 343.5L221.6 351.8C223 352.4 242.3 328.3 242.3 328.3L255.4 328.5S275.9 352.3 277.2 351.8L297.2 344.3C298.6 343.7 297 312.2 297 312.2L306.1 303.1S335.3 304 335.8 302.6L343.9 282.8C344.6 281.7 323 262.1 323 262.1zM278.1 253.4C278.8 270.5 265.3 285 248 285.8 230.7 286.6 215.9 273.3 215.2 256.2 214.5 239.1 228 224.6 245.3 223.9 262.6 223.1 277.4 236.4 278.1 253.4zM479.3 215.5L382.3 118.5 382.2 118.6C307.1 45.3 186.8 45.8 112.4 120.2 61.5 171.2 84.6 148.1 16.7 215.5-5.6 237.8-5.6 274.2 16.7 296.5 86.6 365.9 63.1 342.5 114.1 393.5L114.2 393.4C189.3 466.7 309.6 466.3 384 391.8 435 340.9 411.9 363.9 479.3 296.5 501.6 274.2 501.6 237.8 479.3 215.5zM140.4 363.8C80.8 304.3 80.8 207.8 140.4 148.3 199.9 88.7 296.4 88.8 356 148.3 415.5 207.8 415.6 304.3 356 363.9 296.4 423.4 200 423.3 140.4 363.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/phabricator.js
// module id = py8u
// module chunks = 144